// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconSalaryIncomePath = 'M.04 12.916 10.224.1l6.568 5.216-.283.356 3.464 6.685-14.529 7.535-2.368-4.564L.04 12.916Zm15.219-5.307-10.98 5.694 2.02 3.893 10.979-5.695-2.019-3.892Zm-4.713-4.698 3.432 2.724-.522.655-9.518 4.936 6.608-8.315ZM9.321 13.037a1.596 1.596 0 1 1 2.833-1.47 1.596 1.596 0 0 1-2.833 1.47Z';
var IconSalaryIncome = baseIcon('IconSalaryIncome', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconSalaryIncomePath
});
export default IconSalaryIncome;
//# sourceMappingURL=index.js.map